<script>
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';

  export default {
    components: { ModalMensagem, ModalArquivosSolicitacao  },
    props: {
      pesquisasPassagem: {
        required: true
      },
      filtros: {
        required: false
      },
    },
    data() {
      return {
        animated: false,
        configuracao: this.$storage.configuracao(),
        modalMensagem: false,
        solicitacaoSelecionada: null,
        modalArquivos: false,
      }
    },
    methods: {
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
    },
    computed: {
    }
  }
</script>

<style scoped>
  .mensagemNaoLida {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>

<template> 

  <div class="group">
    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoReembolso : ''"
                    tipo="SolReembolso"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idCompra : ''"
                                tipo="pesquisapreco"
                                :idProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.idProtocolo : ''"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <div class="table-responsive">
      <table class="table table-bordered table-column-code table-column-action">
        <thead>
          <tr>
            <th v-if="!configuracao.naoUtilizarMensageria">Mensagens</th>
            <th class="text-center">Número</th>
            <th>Data solicitação</th>
            <th>Nome solicitante</th>
            <th>Projeto</th>
            <th>Valor (R$)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(pesquisa, index) in pesquisasPassagem">
            <td v-if="!configuracao.naoUtilizarMensageria">
                <div v-if="pesquisa.quantidadeNaoLida > 0">
                    <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{pesquisa.quantidadeNaoLida}}
                </div>
            </td>
            <td class="text-center">{{ pesquisa.idSolicitacaoReembolso || '---' }}</td>
            <td>{{ pesquisa.dataSolicitacao | formatarData }} - {{ pesquisa.dataSolicitacao | formatarHora }}</td>
            <td>{{ pesquisa.solicitante || '---' }}</td>
            <td>{{ pesquisa.nomeProjeto || '---' }}</td>
            <td>{{ pesquisa.valor | formatarNumero }}</td>
            <td>
              <router-link class="btn btn-primary btn-xs"
                           active-class=""
                           v-tooltip="'Visualizar e liberar'"
                           :to="{ name: 'aprovar-passagem.relatorio', params: { id: pesquisa.idSolicitacaoReembolso, filtrosBag: filtros } }">
                <i class="fa fa-file-text-o"></i>
              </router-link>

              <button type="button"
                      class="btn btn-info btn-xs"
                      v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                      @click="mostrarModalArquivos(pesquisa)"
                      v-if="configuracao.usarArquivosCompras">
                <i class="fa fa-archive"></i>
              </button>

              <button type="button"
                      class="btn btn-success btn-xs"
                      v-tooltip="'Ler\Enviar mensagem'"
                      @click="mostrarModalMensagem(pesquisa)"
                      v-if="!configuracao.naoUtilizarMensageria">
                <i class="fa fa-comment"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/aprovar-passagem/componentes/compartilhado/AprovarPassagemLista.vue